<!--Element多选树形控件-->
<template>
	<div class="electricMeterTreeBody">
		<div style="display: flex;padding-top:10px;align-items: center;">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
			</el-input>
		</div>
		<el-scrollbar style="height:95%;width: 100%;">
			<el-tree :data="data"  node-key="pkid" :default-checked-keys="defaultDeviceList" :props="defaultProps" @node-click="nodeClick" :highlight-current='true' default-expand-all :filter-node-method="filterNode" ref="tree">
				<span class="custom-tree-node" slot-scope="{node, data}">
			    <img src="../../../../public/static/image/elTree/1.9.png" v-show="node.data.type=='group'&&node.data.unitid!=''"/>
			 	<img src="../../../../public/static/image/elTree/2.0.png" v-show="node.data.type=='group'&&node.data.unitid==''"/>
			 	<img src="../../../../public/static/image/elTree/2.1.png" v-show="node.data.type=='virtualDevice'"/>
			 	<span style="padding-left: 5px;">{{node.label }}</span>
				</span>
			</el-tree>
		</el-scrollbar>
	</div>
</template>
<script>
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				required: true,
				default: []
			},
		},
		data() {
			return {
				filterText: '',
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				defaultDevice:{},
			}
		},
		created() {},
		mounted() {
			if(!isempty(this.dataList)) {
				this.data = this.dataList
			}
		},
		destroyed() {},
		computed: {
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowVirtualDeviceList(){
				return this.$store.deviceStore.state.nowVirtualDeviceList
			},
			
			defaultDeviceList() {
				let list = this.nowVirtualDeviceList
				let idList = []
				/*if(isempty(list)) {
					if(!isempty(this.dataList)) {
						this.digui(this.dataList)
					}
				} else {
					list.forEach(item => {
						idList.push(item.pkid)
					})
				}*/
				return idList
			},
			getImage() {
				//获取图片
				return img => {
					return resourcesStore.getters.getResourcesByName('energyEfficiencySystem/overview/' + img)
				}
			},
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			},
			dataList(nv, ov) {
				if(!isempty(nv)) {
					this.data = this.dataList
				}
			},
		},
		methods: {
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick(value, nodeData) {
				value.name = value.label
				this.$emit('checkItem',value)
			},
			digui(list) {
				list.forEach(item => {
					if(!isempty(item.children)) {
						this.digui(item.children)
					} else {
						if(item.type == 'virtualDevice') {
							if(isempty(this.nowVirtualDeviceList)){
								this.$store.deviceStore.commit('setNowVirtualDeviceList',[item] )
							}
						}
					}
				})
			}
		}
	}
</script>

<style >
	.electricMeterTreeBody {
		height: 99.8%;
		background-color: white;
		width: 2.5rem;
		border: 1px solid #ded7d7;
		padding-bottom: 20px;
	}
	
	.electricMeterTreeBody .el-scrollbar .el-scrollbar__wrap {
		overflow-x: hidden !important;
	}
	
	.el-tree {
		margin-top: 5px;
	}
	
	.el-tree-node :nth-child(2) {
		padding: 1px;
		overflow: visible;
	}
	
	.electricMeterTreeBody .el-checkbox__inner{
		border: 1px solid #797a7c;
	}
</style>